import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { usePixelStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function PixelGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid />
}

export default function PixelGridLayout() {
  return <GridProvider store={usePixelStore()}>
    <PixelGrid />
  </GridProvider>
}
